module.exports = __webpack_public_path__ + "img/lead_form.924fbf9a.png";